export const displayMatchTypes = {
  is: 'is',
  isNot: 'isNot',
  isAnyOf: 'isAnyOf',
  isNotAnyOf: 'isNotAnyOf',
  startsWith: 'startsWith',
  doesNotStartWith: 'doesNotStartWith',
  endsWith: 'endsWith',
  doesNotEndWith: 'doesNotEndWith',
  contains: 'contains',
  doesNotContain: 'doesNotContain',
  containsOneOf: 'containsOneOf',
  doesNotContainAnyOf: 'doesNotContainAnyOf',
  greaterThan: 'greaterThan',
  lowerThan: 'lowerThan',
  valueInRange: 'valueInRange',
  dateInRange: 'dateInRange',
  notDateInRange: 'notDateInRange',
  amongRegions: 'amongRegions',
  notAmongRegions: 'notAmongRegions',
  olderThan: 'olderThan',
  newerThan: 'newerThan',
  boolean: 'boolean',
}

export const inputCategories = {
  singleValue: 'singleValue',
  multiValue: 'multiValue',
  numeric: 'numeric',
  currency: 'currency',
  range: 'range',
  dateRange: 'dateRange',
  region: 'region',
  daysElapsed: 'daysElapsed',
  boolean: 'boolean',
}

export const currencyFields = [
  'product_value',
  'refund_total_amount',
  'payment_total_amount',
  'order_net_value',
  'order_original_value',
]

export const matchTypeToCategory = {
  [displayMatchTypes.is]: inputCategories.singleValue,
  [displayMatchTypes.isNot]: inputCategories.singleValue,
  [displayMatchTypes.startsWith]: inputCategories.singleValue,
  [displayMatchTypes.doesNotStartWith]: inputCategories.singleValue,
  [displayMatchTypes.endsWith]: inputCategories.singleValue,
  [displayMatchTypes.doesNotEndWith]: inputCategories.singleValue,
  [displayMatchTypes.contains]: inputCategories.singleValue,
  [displayMatchTypes.doesNotContain]: inputCategories.singleValue,
  [displayMatchTypes.isAnyOf]: inputCategories.multiValue,
  [displayMatchTypes.isNotAnyOf]: inputCategories.multiValue,
  [displayMatchTypes.containsOneOf]: inputCategories.multiValue,
  [displayMatchTypes.doesNotContainAnyOf]: inputCategories.multiValue,
  [displayMatchTypes.greaterThan]: inputCategories.numeric,
  [displayMatchTypes.lowerThan]: inputCategories.numeric,
  [displayMatchTypes.valueInRange]: inputCategories.range,
  [displayMatchTypes.dateInRange]: inputCategories.dateRange,
  [displayMatchTypes.notDateInRange]: inputCategories.dateRange,
  [displayMatchTypes.amongRegions]: inputCategories.region,
  [displayMatchTypes.notAmongRegions]: inputCategories.region,
  [displayMatchTypes.olderThan]: inputCategories.daysElapsed,
  [displayMatchTypes.newerThan]: inputCategories.daysElapsed,
  [displayMatchTypes.boolean]: inputCategories.boolean,
}

export const matchTypesWithMatchCase = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.startsWith,
  displayMatchTypes.doesNotStartWith,
  displayMatchTypes.endsWith,
  displayMatchTypes.doesNotEndWith,
  displayMatchTypes.contains,
  displayMatchTypes.doesNotContain,
  displayMatchTypes.containsOneOf,
  displayMatchTypes.doesNotContainAnyOf,
]

export const backendToDisplayMap = {
  is_value: { false: displayMatchTypes.is, true: displayMatchTypes.isNot },
  starts_with: { false: displayMatchTypes.startsWith, true: displayMatchTypes.doesNotStartWith },
  ends_with: { false: displayMatchTypes.endsWith, true: displayMatchTypes.doesNotEndWith },
  contains: { false: displayMatchTypes.contains, true: displayMatchTypes.doesNotContain },
  is_any_of_values: { false: displayMatchTypes.isAnyOf, true: displayMatchTypes.isNotAnyOf },
  contains_any_of_values: { false: displayMatchTypes.containsOneOf, true: displayMatchTypes.doesNotContainAnyOf },
  greater_than: { false: displayMatchTypes.greaterThan },
  lower_than: { false: displayMatchTypes.lowerThan },
  value_in_range: { false: displayMatchTypes.valueInRange },
  date_in_range: { false: displayMatchTypes.dateInRange, true: displayMatchTypes.notDateInRange },
  region_in_list: { false: displayMatchTypes.amongRegions, true: displayMatchTypes.notAmongRegions },
  days_elapsed: { false: displayMatchTypes.olderThan, true: displayMatchTypes.newerThan },
}

export const displayToBackend = {
  [displayMatchTypes.is]: { match_type: 'is_value', exclude_match: false },
  [displayMatchTypes.isNot]: { match_type: 'is_value', exclude_match: true },
  [displayMatchTypes.startsWith]: { match_type: 'starts_with', exclude_match: false },
  [displayMatchTypes.doesNotStartWith]: { match_type: 'starts_with', exclude_match: true },
  [displayMatchTypes.endsWith]: { match_type: 'ends_with', exclude_match: false },
  [displayMatchTypes.doesNotEndWith]: { match_type: 'ends_with', exclude_match: true },
  [displayMatchTypes.contains]: { match_type: 'contains', exclude_match: false },
  [displayMatchTypes.doesNotContain]: { match_type: 'contains', exclude_match: true },
  [displayMatchTypes.isAnyOf]: { match_type: 'is_any_of_values', exclude_match: false },
  [displayMatchTypes.isNotAnyOf]: { match_type: 'is_any_of_values', exclude_match: true },
  [displayMatchTypes.containsOneOf]: { match_type: 'contains_any_of_values', exclude_match: false },
  [displayMatchTypes.doesNotContainAnyOf]: { match_type: 'contains_any_of_values', exclude_match: true },
  [displayMatchTypes.greaterThan]: { match_type: 'greater_than', exclude_match: false },
  [displayMatchTypes.lowerThan]: { match_type: 'lower_than', exclude_match: false },
  [displayMatchTypes.valueInRange]: { match_type: 'value_in_range', exclude_match: false },
  [displayMatchTypes.dateInRange]: { match_type: 'date_in_range', exclude_match: false },
  [displayMatchTypes.notDateInRange]: { match_type: 'date_in_range', exclude_match: true },
  [displayMatchTypes.amongRegions]: { match_type: 'region_in_list', exclude_match: false },
  [displayMatchTypes.notAmongRegions]: { match_type: 'region_in_list', exclude_match: true },
  [displayMatchTypes.olderThan]: { match_type: 'days_elapsed', exclude_match: false },
  [displayMatchTypes.newerThan]: { match_type: 'days_elapsed', exclude_match: true },
  [displayMatchTypes.boolean]: { match_type: 'boolean', exclude_match: false },
}

export const fullTextMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.startsWith,
  displayMatchTypes.doesNotStartWith,
  displayMatchTypes.endsWith,
  displayMatchTypes.doesNotEndWith,
  displayMatchTypes.contains,
  displayMatchTypes.doesNotContain,
  displayMatchTypes.containsOneOf,
  displayMatchTypes.doesNotContainAnyOf,
]

export const idMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
]

export const skuMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.startsWith,
  displayMatchTypes.doesNotStartWith,
  displayMatchTypes.endsWith,
  displayMatchTypes.doesNotEndWith,
]

export const anyOfMatchTypes = [displayMatchTypes.isAnyOf, displayMatchTypes.isNotAnyOf]

export const urlSlugMatchTypes = [displayMatchTypes.is, displayMatchTypes.isNot]

export const idAndNumericMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.greaterThan,
  displayMatchTypes.lowerThan,
]

export const numericComparisonMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.greaterThan,
  displayMatchTypes.lowerThan,
  displayMatchTypes.valueInRange,
]

export const numberMatchTypes = [
  displayMatchTypes.is,
  displayMatchTypes.isNot,
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.startsWith,
  displayMatchTypes.doesNotStartWith,
  displayMatchTypes.endsWith,
  displayMatchTypes.doesNotEndWith,
  displayMatchTypes.greaterThan,
  displayMatchTypes.lowerThan,
]

export const regionMatchTypes = [displayMatchTypes.amongRegions, displayMatchTypes.notAmongRegions]

export const numericRangeMatchTypes = [
  displayMatchTypes.valueInRange,
  displayMatchTypes.greaterThan,
  displayMatchTypes.lowerThan,
]

export const multiValueMatchTypes = [
  displayMatchTypes.isAnyOf,
  displayMatchTypes.isNotAnyOf,
  displayMatchTypes.containsOneOf,
  displayMatchTypes.doesNotContainAnyOf,
]

export const dateRangeMatchTypes = [displayMatchTypes.dateInRange, displayMatchTypes.notDateInRange]
export const daysElapsedMatchTypes = [displayMatchTypes.olderThan, displayMatchTypes.newerThan]

export const matchTypeLabels = {
  [displayMatchTypes.is]: 'Es igual a',
  [displayMatchTypes.isNot]: 'No es igual a',
  [displayMatchTypes.isAnyOf]: 'Es uno de',
  [displayMatchTypes.isNotAnyOf]: 'No es ninguno de',
  [displayMatchTypes.startsWith]: 'Empieza por',
  [displayMatchTypes.doesNotStartWith]: 'No empieza por',
  [displayMatchTypes.endsWith]: 'Termina con',
  [displayMatchTypes.doesNotEndWith]: 'No termina con',
  [displayMatchTypes.contains]: 'Contiene',
  [displayMatchTypes.doesNotContain]: 'No contiene',
  [displayMatchTypes.containsOneOf]: 'Contiene uno de',
  [displayMatchTypes.doesNotContainAnyOf]: 'No contiene ninguno de',
  [displayMatchTypes.greaterThan]: 'Mayor que',
  [displayMatchTypes.lowerThan]: 'Menor que',
  [displayMatchTypes.valueInRange]: 'Valor en rango',
  [displayMatchTypes.olderThan]: 'Más antigua que',
  [displayMatchTypes.newerThan]: 'Más reciente que',
  [displayMatchTypes.dateInRange]: 'En rango de fechas',
  [displayMatchTypes.notDateInRange]: 'No en rango de fechas',
  [displayMatchTypes.amongRegions]: 'Entre las regiones',
  [displayMatchTypes.notAmongRegions]: 'No entre las regiones',
  [displayMatchTypes.boolean]: 'Sí / No',
}

export const nonBlankValueFields = ['order_source']

export const missingValueMessages = {
  empty: 'Este campo es obligatorio',
  blank: 'Introduce un valor',
}
